import { AssistantPageContext, pageContextNoun } from '../assistantPageContext'

/**
 * The text a placement's quick question is sent as. The placement's record (`record`, what the
 * placement sits on) is normally the question's context (`active`, what goes with the question):
 * the question is then sent as it is. When that context is not there (the server refused it, the
 * tool that reads that kind of record is off, or the chip was removed where it can be), the
 * record goes along in the text, "<question> (<noun> <label>)", so "this case" still names it.
 */
export const placementQuestionText = (
  question: string,
  record: AssistantPageContext | null | undefined,
  active: AssistantPageContext | null
) => {
  const onRecord =
    !!record &&
    !!record.id &&
    !!active &&
    !active.list &&
    active.type === record.type &&
    active.id === record.id.toLowerCase()
  const label = (record?.label ?? '').trim()
  return onRecord || !record || !label
    ? question
    : `${question} (${pageContextNoun(record.type)} ${label})`
}
